import React, { useState, useEffect, useCallback } from 'react';
import ApplicantTable from './ApplicantTable';
function App({ keycloak, isAuthenticated }) {

  // Solo cargar los videos si el usuario está autenticado
  useEffect(() => {
    if (isAuthenticated) {
      //fetchVideos(); // Cargar los videos cuando esté autenticado
    }
  }, [isAuthenticated]);

  return <ApplicantTable/>;
}

export default App;